<script setup lang="ts">
import { useSiteStore } from '~/stores/site.store';
import ExternalIcon from '~/components/design-system/icons/ExternalIcon.vue';

const siteStore = useSiteStore();
const route = useRoute();
const emits = defineEmits(['toggleHamburger']);

const gameCategories = computed(() => {
  return siteStore
    .getNav({ nav: 'top' })
    .filter(
      (category) =>
        category.MobileApp.enabled &&
        category.MobileApp.component === 'CasinoComponent',
    );
});

const activeGameCategory = computed(() => (categoryChild) => {
  return route.fullPath === categoryChild.Mapping;
});
</script>
<template>
  <div>
    <div v-for="(category, i) in gameCategories" :key="i" class="mb-2">
      <DesignSystemAccordion
        v-if="category.Children.length > 0"
        title="my-account"
        :classes="{
          title: 'text-xs !font-bold',
          header: 'bg-layer',
          icon: '!w-4 !h-4',
          content: 'bg-layer rounded-b-lg !px-0 !pb-0',
        }"
        size="lg"
      >
        <template #title>
          <div class="flex items-center gap-2">
            <ExternalIcon class="mx-0 w-4 h-4" :icon-name="category.Alias" />
            <span class="text-base-priority">
              {{ $t(`Vertical.${category.Alias}`) }}
            </span>
          </div>
        </template>
        <div
          v-for="(categoryChild, j) in category.Children"
          :key="`${i}-${j}`"
          :class="[
            {
              'dark:bg-dark-900 bg-light-300':
                activeGameCategory(categoryChild),
            },
            ' hover:bg-light-100 hover:dark:bg-dark-700',
          ]"
          @click="emits('toggleHamburger')"
        >
          <NuxtLink :to="categoryChild.RelativeUrl" class="p-2 flex">
            <span
              class="ml-3 text-xs font-normal text-base-priority capitalize"
            >
              {{
                $t(
                  `vertical.category.${categoryChild.Alias}-${siteStore.getRegionCode}`,
                  `vertical.category.${categoryChild.Alias}`,
                )
              }}
            </span>
          </NuxtLink>
        </div>
      </DesignSystemAccordion>
      <NuxtLink v-else :to="category.Path">
        <div
          class="w-full bg-layer rounded-lg flex gap-2 items-center p-2"
          @click="emits('toggleHamburger')"
        >
          <ExternalIcon class="!mx-0 w-4 h-4" :icon-name="category.Alias" />
          <span class="text-base-priority text-xs font-bold">
            {{ $t(`Vertical.${category.Alias}`) }}
          </span>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>
